import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsComponent } from './tabs.component';
import { TranslateModule } from '@ngx-translate/core';
import { ElementsModule } from '@shared/elements/elements.module';

@NgModule({
    imports: [
        CommonModule,
        ElementsModule,
        TranslateModule
    ],
    exports: [
        TabsComponent
    ],
    declarations: [
        TabsComponent
    ]
})
export class TabsComponentModule {}
